export interface SystemUser {
  id: string;
  name: string;
  email: string;
  phone: string;
  role: string;
  status: 'active' | 'inactive' | 'pending';
  lastLogin: string;
  createdAt: string;
}

export const availableRoles: string[] = [
  'Super Admin',
  'Admin',
  'Coordinator',
  'Teacher',
  'Therapist',
  'Parent',
  'Student',
  'Accountant',
  'Librarian',
  'Receptionist',
];

export const systemUsers: SystemUser[] = [
  {
    id: 'usr-001',
    name: 'Alexandra Reed',
    email: 'a.reed@xlplatform.edu',
    phone: '+91 98123 45001',
    role: 'Super Admin',
    status: 'active',
    lastLogin: '2026-07-30 08:45 AM',
    createdAt: '2024-01-15',
  },
  {
    id: 'usr-002',
    name: 'Dr. Rajesh Kumar',
    email: 'r.kumar@xlplatform.edu',
    phone: '+91 98123 45002',
    role: 'Admin',
    status: 'active',
    lastLogin: '2026-07-29 04:20 PM',
    createdAt: '2024-02-10',
  },
  {
    id: 'usr-003',
    name: 'Ms. Emily Watson',
    email: 'emily.watson@xlplatform.edu',
    phone: '+91 98123 45670',
    role: 'Teacher',
    status: 'active',
    lastLogin: '2026-07-30 07:30 AM',
    createdAt: '2024-03-05',
  },
  {
    id: 'usr-004',
    name: 'Ms. Jennifer Lee',
    email: 'jennifer.lee@xlplatform.edu',
    phone: '+91 98123 45671',
    role: 'Teacher',
    status: 'active',
    lastLogin: '2026-07-30 08:00 AM',
    createdAt: '2024-03-10',
  },
  {
    id: 'usr-005',
    name: 'Dr. Sarah Mitchell',
    email: 'sarah.mitchell@xlplatform.edu',
    phone: '+91 98123 45672',
    role: 'Therapist',
    status: 'active',
    lastLogin: '2026-07-30 08:15 AM',
    createdAt: '2024-04-01',
  },
  {
    id: 'usr-006',
    name: 'Mr. James Okafor',
    email: 'james.okafor@xlplatform.edu',
    phone: '+91 98123 45673',
    role: 'Teacher',
    status: 'active',
    lastLogin: '2026-07-29 03:10 PM',
    createdAt: '2024-04-15',
  },
  {
    id: 'usr-007',
    name: 'Ms. Emma Reyes',
    email: 'emma.reyes@xlplatform.edu',
    phone: '+91 98123 45674',
    role: 'Therapist',
    status: 'active',
    lastLogin: '2026-07-30 07:45 AM',
    createdAt: '2024-05-20',
  },
  {
    id: 'usr-008',
    name: 'Mr. David Kumar',
    email: 'david.kumar@xlplatform.edu',
    phone: '+91 98123 45675',
    role: 'Coordinator',
    status: 'inactive',
    lastLogin: '2026-07-15 11:30 AM',
    createdAt: '2024-06-01',
  },
  {
    id: 'usr-009',
    name: 'Ms. Priya Nair',
    email: 'priya.nair@xlplatform.edu',
    phone: '+91 98123 45676',
    role: 'Teacher',
    status: 'active',
    lastLogin: '2026-07-29 02:45 PM',
    createdAt: '2024-06-15',
  },
  {
    id: 'usr-010',
    name: 'Mr. Arjun Desai',
    email: 'arjun.desai@xlplatform.edu',
    phone: '+91 98123 45677',
    role: 'Therapist',
    status: 'active',
    lastLogin: '2026-07-30 06:50 AM',
    createdAt: '2024-07-01',
  },
  {
    id: 'usr-011',
    name: 'Ms. Fatima Sheikh',
    email: 'fatima.sheikh@xlplatform.edu',
    phone: '+91 98123 45678',
    role: 'Coordinator',
    status: 'active',
    lastLogin: '2026-07-29 05:30 PM',
    createdAt: '2024-07-10',
  },
  {
    id: 'usr-012',
    name: 'Mr. Ravi Menon',
    email: 'ravi.menon@xlplatform.edu',
    phone: '+91 98123 45679',
    role: 'Accountant',
    status: 'active',
    lastLogin: '2026-07-28 01:00 PM',
    createdAt: '2024-08-01',
  },
  {
    id: 'usr-013',
    name: 'Ms. Kavita Joshi',
    email: 'kavita.joshi@xlplatform.edu',
    phone: '+91 98123 45682',
    role: 'Receptionist',
    status: 'active',
    lastLogin: '2026-07-30 08:30 AM',
    createdAt: '2024-08-15',
  },
  {
    id: 'usr-014',
    name: 'Mr. Sanjay Patil',
    email: 'sanjay.patil@xlplatform.edu',
    phone: '+91 98123 45683',
    role: 'Teacher',
    status: 'active',
    lastLogin: '2026-07-29 09:15 AM',
    createdAt: '2024-09-01',
  },
  {
    id: 'usr-015',
    name: 'Ms. Ananya Gupta',
    email: 'ananya.gupta@xlplatform.edu',
    phone: '+91 98123 45680',
    role: 'Teacher',
    status: 'pending',
    lastLogin: '—',
    createdAt: '2026-07-28',
  },
  {
    id: 'usr-016',
    name: 'Mr. Vikram Rao',
    email: 'vikram.rao@xlplatform.edu',
    phone: '+91 98123 45681',
    role: 'Librarian',
    status: 'inactive',
    lastLogin: '2026-06-20 10:00 AM',
    createdAt: '2024-11-01',
  },
  {
    id: 'usr-017',
    name: 'Ms. Lakshmi Iyer',
    email: 'lakshmi.iyer@xlplatform.edu',
    phone: '+91 98123 45684',
    role: 'Coordinator',
    status: 'active',
    lastLogin: '2026-07-29 11:00 AM',
    createdAt: '2025-01-05',
  },
  {
    id: 'usr-018',
    name: 'Mr. Carlos Menezes',
    email: 'carlos.menezes@xlplatform.edu',
    phone: '+91 98123 45685',
    role: 'Teacher',
    status: 'active',
    lastLogin: '2026-07-30 07:00 AM',
    createdAt: '2025-02-10',
  },
];